import { RteComputationVersionEnum, SiteContryEnum, SiteOperatorEnum } from "shared/enums/globalEnums";

export const socRelatedFieldValidation = (value: number, source: string, allValues: any) => {
  const { soc_reserve_inf, soc_inf, soc_sup, soc_reserve_up } = allValues;
  switch (source) {
    case "soc_reserve_inf":
      if (soc_reserve_up && value >= soc_reserve_up) {
        return "Must be lower than soc_reserve_up";
      }
      break;
    case "soc_inf":
      if (soc_sup && value >= soc_sup) {
        return "Must be lower than soc_sup";
      }
      break;
    case "soc_sup":
      if (soc_inf && value <= soc_inf) {
        return "Must be higher than soc_inf";
      }
      break;
    case "soc_reserve_up":
      if (soc_reserve_inf && value <= soc_reserve_inf) {
        return "Must be higher than soc_reserve_inf";
      }
      break;

    default:
      break;
  }
  return undefined;
};

export const socValidations = (value: number, allValues: any, inputInfos: any) => {
  if (!value) {
    return undefined;
  }
  if (value <= 0 || value >= 100) {
    return "Must be between 0 and 100";
  }
  const { source } = inputInfos;
  return socRelatedFieldValidation(value, source, allValues);
};

// Define the type for the validation errors object
type ValidationErrors<T> = Partial<Record<keyof T, string>>;

export interface SiteCreate {
  id?: number;
  name: string;
  country: SiteContryEnum;
  dso?: string;
  supplier?: string;
  soc_inf?: number;
  soc_sup?: number;
  soc_reserve_inf?: number;
  soc_reserve_sup?: number;
  useful_energy_at_1mw?: number;
  rte_fcr_computation_version?: RteComputationVersionEnum;
  site_operator?: SiteOperatorEnum;
  configuration: {
    power_mw?: number;
    efficiency_roundtrip?: number;
    rte_fcr_computation_version?: RteComputationVersionEnum;
  };
  // Add other fields as necessary
}

export const siteValidations = (values: any): ValidationErrors<SiteCreate> => {
  const isRequiredMessage = "This field is required";
  const errors: any = {
    desired_configuration: {},
  };
  // const errors: ValidationErrors<SiteCreate> = {};
  if (!values.id) {
    errors.id = isRequiredMessage;
  }
  // Validate the name field
  if (!values.name) {
    errors.name = isRequiredMessage;
  }
  // Validate the country field
  if (!values.country) {
    errors.country = isRequiredMessage;
  }
  // Validate country-specific fields (e.g., France and Finland)
  if (!values.dso) {
    errors.dso = isRequiredMessage;
  }
  if (!values.supplier) {
    errors.supplier = isRequiredMessage;
  }
  if (!values.site_operator) {
    errors.site_operator = isRequiredMessage;
  }

  // Validate the desired_configuration object
  if (values.desired_configuration) {
    // Validate the power_mw field
    if (!values.desired_configuration.power_mw) {
      errors.desired_configuration.power_mw = isRequiredMessage;
    } else {
      // Validate the power_mw field to be a positive number
      if (values.desired_configuration.power_mw < 0) {
        errors.desired_configuration.power_mw = "Must be a positive number";
      }
    }
    // Validate the efficiency_roundtrip field
    if (values.desired_configuration.efficiency_roundtrip == null) {
      errors.desired_configuration.efficiency_roundtrip = isRequiredMessage;
    } else {
      // Validate the efficiency_roundtrip field to be a positive number
      if (
        values.desired_configuration.efficiency_roundtrip < 0 ||
        values.desired_configuration.efficiency_roundtrip > 1
      ) {
        errors.desired_configuration.efficiency_roundtrip = "Must be a number between 0 and 1";
      }
    }
    // Validate the rte_fcr_computation_version field
    if (
      values.desired_configuration.rte_fcr_computation_version == null ||
      values.desired_configuration.rte_fcr_computation_version === ""
    ) {
      errors.desired_configuration.rte_fcr_computation_version = isRequiredMessage;
    }
  }

  // Return the errors object, if empty no validation error exists
  return errors;
};
